import { render, staticRenderFns } from "./digital-currency-13-digital-currency-feature-list.vue?vue&type=template&id=f9766702&scoped=true&"
import script from "./digital-currency-13-digital-currency-feature-list.vue?vue&type=script&lang=ts&"
export * from "./digital-currency-13-digital-currency-feature-list.vue?vue&type=script&lang=ts&"
import style0 from "./digital-currency-13-digital-currency-feature-list.vue?vue&type=style&index=0&id=f9766702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9766702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
